export const FAV_STATIONS_TITLE = 'Favoriete zenders';
export const FAV_STATION_SUBTITLE = 'Nog geen opgeslagen radiozenders';
export const FAV_STATION_TEXT = 'op een zender om deze toe te voegen';
export const FAV_PODCASTS_TITLE = 'Favoriete podcasts';
export const FAV_PODCASTS_SUBTITLE = 'Nog geen opgeslagen podcasts';
export const FAV_PODCASTS_TEXT = 'op een podcast om deze toe te voegen';
